module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.menuChildren.length !== 0) ? _c('div', {
    staticClass: "goods_left"
  }, [_c('div', {
    staticClass: "cate"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.menuName))]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('ul', _vm._l((_vm.menuChildren), function(child, i) {
    return _c('li', {
      class: {
        'selected': _vm.childId === child.id
      },
      on: {
        "click": function($event) {
          return _vm.jumpgo('/designlist', child.id)
        }
      }
    }, [_vm._v(_vm._s(child.alias))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "advace"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.jumpgo('/search')
      }
    }
  }, [_vm._v("Advance Search")])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bd54930","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design_goods_left.vue
// module id = 539
// module chunks = 63